import { Injectable } from "@angular/core";
import { DataTableConfig } from "../data-table/data-table-service.type";
import { DataTable, DataTableColumn, GetDataEvent } from "../data-table/data-table.type";
import { Data } from "./pie-chart.type";
import { of } from "rxjs";
import { Params } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class PieChartTableService {
  constructor() {}

  getTableConfig = (config?: DataTableConfig<Data>): DataTable<Data> => {
    const { id, bodyHeight, queryParamsDetails } = config || {};
    const _columns: DataTableColumn<Data>[] = [
      {
        name: "Color",
        width: 50,
        draggable: false,
        resizeable: false,
        hidden: false,
        icon: {
          name: (row) => {
            return this.getColorIcon(row).name;
          },
          color: (row) => this.getColorIcon(row).color,
        },
      },
      {
        prop: "label",
        name: "Status",
        hidden: false,
        width: 100,
        draggable: false,
        resizeable: false,
        link: {
          path: () => `/${queryParamsDetails.alias}`,
          queryParams: (row) => this.getQueryParams(row, queryParamsDetails),
        },
      },
      {
        prop: "value",
        name: "Count",
        width: 50,
        draggable: false,
        resizeable: false,
      },
    ] as DataTableColumn<Data>[];
    return {
      id: id ?? "pieChart",
      scrollbarH: false,
      scrollbarV: false,
      entityName: null,
      externalPaging: false,
      externalSorting: false,
      bodyHeight,
      toolBar: {
        hidden: true,
      },
      columns: _columns,
      boxShadow: false,
      paginator: {
        hidden: true,
      },
      footerHeight: 0,
      syncWithQueryParams: true,
    };
  };

  chartTableGetData = (event: GetDataEvent<Data>, data: Data[]): void => {
    const { onError, onResult } = event;
    of(data).subscribe((d) => {
      onResult(d);
    }, onError);
  };

  getFilterParam(alias: string): string {
    return `${alias}_0_filter`;
  }

  getValueParam(alias: string): string {
    return `${alias}_0_value`;
  }

  /** Get color icon  */
  private getColorIcon = (data: Data): { name: string; color: string } => {
    return { name: "circle", color: data.colors.background };
  };

  /** Get queryParams for pie chart status link  */
  private getQueryParams = (data: Data, path: any): Params => {
    const value = path.labels.find((opt) => opt.label === data.label).value;
    const filter = path.filter;

    const queryParams: Params = {
      [this.getValueParam(path.alias)]: value,
      [this.getFilterParam(path.alias)]: filter,
    };
    return queryParams;
  };
}
